import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { userType } from './constants/global-constants';
import { AuthService } from './services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) { }
  
  user: userType;


  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if(route.data.role == userType.BOTH && this.authService.user)
      {
        return true;
      }
      else if(route.data.role == this.authService.user?.userType)
      {
        return true;
      }
      else{
        this.router.navigate(['/home']);
        return false;
      }
  }
  
}
